import React from 'react';
import { Icon, Typography } from 'antd';
import CardTemplate from '../../../../shared/ui/CardTemplate';
import PhoneBlock from '../../../../../../components/PhoneBlock';
import { ReactComponent as MailIcon } from '../../../../../../resource/EmailAdaptiveIcon.svg';
import styles from './index.module.scss';

const iconConfig = { position: 'left' };

const ClientBlock = ({ client }) => {
  const phoneNumber = client.phone?.trim();
  const email = client.email?.trim();

  return (
    <CardTemplate dark>
      <Typography.Text>
        {client.name}{' '}
        <Typography.Text strong>
          ({client.isOwner ? 'собственник' : 'житель'})
        </Typography.Text>
      </Typography.Text>

      {Boolean(phoneNumber) && (
        <PhoneBlock
          name={client.name}
          number={phoneNumber}
          iconConfig={iconConfig}
          rootClassName={styles.row}
        />
      )}

      {Boolean(email) && (
        <div className={styles.row}>
          <Icon component={MailIcon} />{' '}
          <Typography.Text>{email}</Typography.Text>
        </div>
      )}
    </CardTemplate>
  );
};

export default ClientBlock;
